import { TeamList } from '@organization/api/requests'
import { paths } from '@organization/router'
import { dateTimeFormat } from '@organization/utils'
import { TableActions, Text } from '@shared/components'
import { Flex } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { MenuProps } from 'antd/lib'
import dayjs from 'dayjs'

import { Profile2User } from 'iconsax-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export const useTeamColumns = (
  getActions: (user: TeamList) => MenuProps['items']
) => {
  const { t } = useTranslation()

  const columns: ColumnsType<TeamList> = [
    {
      key: 'name',
      sorter: true,
      title: t('table.name'),
      render: (_, { name, id }) => (
        <Link to={paths.teams.details(String(id))}>
          <Flex align="center" gap={8}>
            <Profile2User size="16" />
            <Text>{name}</Text>
          </Flex>
        </Link>
      )
    },
    {
      key: 'date_created',
      sorter: true,
      width: 200,
      title: t('table.date_created'),
      dataIndex: ['user', 'date_created'],
      render: (_, { date_created }) =>
        date_created ? dayjs(date_created).format(dateTimeFormat) : '-'
    },
    {
      key: 'users',
      title: t('table.users'),
      align: 'center',
      render: (_, { top_users }) => (
        <Flex justify="center" gap={8}>
          <Text>{top_users?.length}</Text>
        </Flex>
      )
    },
    {
      key: 'actions',
      align: 'center',
      width: 80,
      render: (_, row) => <TableActions options={getActions(row)} />
    }
  ]

  return columns
}
